import React from 'react';
import DefaultLayout from "./DefaultLayout";
import { Container } from '@mui/material';

const LayoutWithHeader = ({children}) => {
  return (
    <DefaultLayout navbar={false}>
      <Container maxWidth="xl">
        {children}
      </Container>
    </DefaultLayout>
  );
}
 
export default React.memo(LayoutWithHeader);
